export const MESSENGER_DOMAIN = "https://messenger.customerly.io/launcher.js";
export const MESSENGER_BETA_DOMAIN =
  "https://messenger.staging.customerly.io/launcher.js";
